export var TransportType;
(function (TransportType) {
    TransportType["BUS"] = "BUS";
    TransportType["TRAM"] = "TRAM";
    TransportType["URBAN_TRAIN"] = "URBAN_TRAIN";
    TransportType["TRAIN"] = "TRAIN";
    TransportType["METRO"] = "METRO";
    TransportType["RER"] = "RER";
})(TransportType || (TransportType = {}));
